import React, {useState} from 'react'
import {Form, Modal, Segment} from 'semantic-ui-react'
import {tr} from '../../helpers/languages'
import {sendMail} from '../../helpers/requests'
import GoogleLogin from "react-google-login";
import {bindActionCreators} from "redux";
import {actions as profiles} from "../../store/actions/profiles";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {actions as messages} from "../../store/actions/messages";

const ContactModal = (props) => {
    const [emailFields, setEmailFields] = useState({
        email: props.email,
        subject: '',
        body: ''
    })

    // const callParticipant = () => {
    //
    //     props.onClose()
    // }

    const copyPhone = () => {
        navigator.clipboard.writeText(props.phoneNumber)
    }

    // const copyMail = () => {
    //     navigator.clipboard.writeText(props.email)
    // }

    const responseGoogle = (response) => {
        console.log(response);
        sendMail(props.therapist_email, props.email, emailFields.subject, emailFields.body, response.accessToken)
            .then(res => {
                props.message({type: 'info', text: tr('YOUR_EMAIL_HAS_BEEN_SENT')})
                props.onClose()
            })
            .catch(error => {
                props.message({type: 'error', text: tr('FAILED_TO_SEND_EMAIL')})
            })
    }

    // const sendEmail = () => {
    //
    //     props.onClose()
    // }

    const changeValue = (event) => {
        const {name, value} = event.target
        setEmailFields({...emailFields, [name]: value})
    }

    return (
        <Modal className='contact' open onClose={(_e) => {
            props.onClose()
        }}>
            <Modal.Content>
                <Segment className={'contact-title phone'}>
                    {tr('PHONE_NUMBER') + ':'}
                    <Segment className={'contact-text phone'} onClick={copyPhone}>
                        {props.phoneNumber}
                    </Segment>
                    {/*<Button className='call' onClick={callParticipant}>{tr('CALL')}</Button>*/}
                </Segment>
                {/*<Segment className={'contact-title phone'}>*/}
                {/*    {tr('EMAIL') + ':'}*/}
                {/*    <Segment className={'contact-text phone'} onClick={copyMail}>*/}
                {/*        {props.email}*/}
                {/*    </Segment>*/}
                {/*    /!*<Button className='call' onClick={callParticipant}>{tr('CALL')}</Button>*!/*/}
                {/*</Segment>*/}
                <Segment className={'contact-title email'}>
                    {tr('EMAIL')}
                </Segment>
                <Segment>
                    <Form>
                        <Form.Field>
                            <label> {tr('TO')}</label>
                            <input
                                name='email'
                                value={props.email}
                                disabled={true}
                                onChange={changeValue}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label> {tr('SUBJECT')}</label>
                            <input
                                name='subject'
                                maxLength={100}
                                onChange={changeValue}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>{tr('BODY')}</label>
                            <textarea
                                name='body'
                                onChange={changeValue}
                            />
                        </Form.Field>
                        <GoogleLogin
                            clientId="580248358705-rc71kk10beff5ld770pa6b6fs9fj8dqc.apps.googleusercontent.com"
                            render={renderProps => (
                                <Form.Button className={'send-email'}
                                             onClick={renderProps.onClick} disabled={renderProps.disabled}
                                >
                                    {tr('SEND_EMAIL')}
                                </Form.Button>
                            )}
                            buttonText="Login"
                            onSuccess={responseGoogle}
                            onFailure={responseGoogle}
                            cookiePolicy={'single_host_origin'}
                        />

                    </Form>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

const mapStateToProps = (state) => {
    return {
        therapist_email: state.profiles.profile.email,
    }
}
const mapDispatchToProps = (dispatch) => {
    const _profiles = bindActionCreators(profiles, dispatch)
    const _messages = bindActionCreators(messages, dispatch)
    return {
        setProfile: _profiles.setProfile,
        message: _messages.message
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactModal))





// WEBPACK FOOTER //
// ./src/components/contact-modal/index.js